<template>
  <div class="d-flex">
    <v-tooltip v-if="backward.length > 3" content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="moveBackward(backward[3])" v-bind="attrs" v-on="on" class="mr-1" x-small>
          <v-icon small>
            mdi-arrow-collapse-left
          </v-icon>
        </v-btn>
      </template>
      <span>{{ prevTooltip(backward[3]) }}</span>
    </v-tooltip>
    <v-tooltip v-if="backward.length > 2" content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="moveBackward(backward[2])" v-bind="attrs" v-on="on" class="mr-1" x-small>
          <v-icon small>
            mdi-chevron-triple-left
          </v-icon>
        </v-btn>
      </template>
      <span>{{ prevTooltip(backward[2]) }}</span>
    </v-tooltip>
    <v-tooltip v-if="backward.length > 1" content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="moveBackward(backward[1])" v-bind="attrs" v-on="on" class="mr-1" x-small>
          <v-icon small>
            mdi-skip-backward
          </v-icon>
        </v-btn>
      </template>
      <span>{{ prevTooltip(backward[1]) }}</span>
    </v-tooltip>
    <v-tooltip content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="moveBackward(backward[0])" v-bind="attrs" v-on="on" class="mr-1" x-small>
          <v-icon small>
            mdi-skip-previous
          </v-icon>
        </v-btn>
      </template>
      <span>{{ prevTooltip(backward[0]) }}</span>
    </v-tooltip>
    <date-time-range-picker-neo v-model="datetimes" :disabledQuickPick="disabledQuickPick"></date-time-range-picker-neo>
    <v-tooltip content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="moveForward(forward[0])" v-bind="attrs" v-on="on" class="mr-1" x-small>
          <v-icon small>
            mdi-skip-next
          </v-icon>
        </v-btn>
      </template>
      <span>{{ nextTooltip(forward[0]) }}</span>
    </v-tooltip>
    <v-tooltip v-if="forward.length > 1" content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="moveForward(forward[1])" v-bind="attrs" v-on="on" class="mr-1" x-small>
          <v-icon small>
            mdi-skip-forward
          </v-icon>
        </v-btn>
      </template>
      <span>{{ nextTooltip(forward[1]) }}</span>
    </v-tooltip>
    <v-tooltip v-if="forward.length > 2" content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="moveForward(forward[2])" v-bind="attrs" v-on="on" class="mr-1" x-small>
          <v-icon small>
            mdi-chevron-triple-right
          </v-icon>
        </v-btn>
      </template>
      <span>{{ nextTooltip(forward[2]) }}</span>
    </v-tooltip>
    <v-tooltip v-if="forward.length > 3" content-class="tooltip" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="moveForward(forward[3])" v-bind="attrs" v-on="on" class="mr-1" x-small>
          <v-icon small>
            mdi-arrow-collapse-right
          </v-icon>
        </v-btn>
      </template>
      <span>{{ nextTooltip(forward[3]) }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { startOfDay, endOfDay, addSeconds, subSeconds, addMinutes, subMinutes, addHours, subHours, addDays, subDays, addWeeks, subWeeks, addMonths, subMonths, addYears, subYears } from 'date-fns';
import { s2Hms } from '@/utils/formatter.js';

export default {
  props: {
    value: {
      type: Array,
      default: () => {
        return [startOfDay(new Date()), endOfDay(new Date())];
      },
    },
    disabledQuickPick: {
      type: Boolean,
      default: false,
    },
    disabledSeconds: {
      type: Boolean,
      default: false,
    },
    // BEGIN::Added.by.KWShin.2025.10.20
    // 이전/이후 간격이 10분/1시간으로 고정된 것을 유동화하기 위해 추가.
    backward: {
      type: Array,
      default: () => {
        return ['10m', '1h', '1D', '1M'];
      },
    },
    forward: {
      type: Array,
      default: () => {
        return ['10m', '1h', '1D', '1M'];
      },
    },
  },
  data() {
    return {
      datetimes: this.value,
    };
  },
  watch: {
    // BEGIN::Added.by.KWShin.2025.11.12.
    // 여태 이런 사용 경우가 없었나??
    // 부모쪽에서 props 'value'를 바꾸어 주어도 이 컴포넌트는 그걸 반영하지 못한다.
    // 부모쪽에서 props 'value'를 바꾸면 반응할 수 있도록 추가하였다.
    value(val) {
      this.datetimes = val;
    },
    // FINISH::Added.by.KWShin.2025.11.12.
    datetimes(value) {
      this.emit(value);
    },
  },
  methods: {
    // moveBackward()와 moveForware() 공히 시간 단위로 움직이던 것을
    // 분단위로 바꿈.2022.11.24.KWShin.
    // 다시 초단위로 바꿈.2025.10.20.KWShin.
    // 다시 YMWDhms 단위로 바꿈.2026.09.03.KWShin.
    moveBackward(term) {
      const qntt = parseInt(term.substring(0, term.length - 1));
      const unit = term.substring(term.length - 1);
      switch (unit) {
        case 'Y':
          this.datetimes.splice(1, 1, subYears(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, subYears(this.datetimes[0], qntt));
          break;
        case 'M':
          this.datetimes.splice(1, 1, subMonths(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, subMonths(this.datetimes[0], qntt));
          break;
        case 'W':
          this.datetimes.splice(1, 1, subWeeks(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, subWeeks(this.datetimes[0], qntt));
          break;
        case 'D':
          this.datetimes.splice(1, 1, subDays(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, subDays(this.datetimes[0], qntt));
          break;
        case 'h':
          this.datetimes.splice(1, 1, subHours(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, subHours(this.datetimes[0], qntt));
          break;
        case 'm':
          this.datetimes.splice(1, 1, subMinutes(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, subMinutes(this.datetimes[0], qntt));
          break;
        case 's':
          this.datetimes.splice(1, 1, subSeconds(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, subSeconds(this.datetimes[0], qntt));
          break;
        default:
          console.log('in DateTimeRangeNavigator, ERROR - Unknown backward term unit.');
      }
      this.emit();
    },
    moveForward(term) {
      const qntt = parseInt(term.substring(0, term.length - 1));
      const unit = term.substring(term.length - 1);
      switch (unit) {
        case 'Y':
          this.datetimes.splice(1, 1, addYears(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, addYears(this.datetimes[0], qntt));
          break;
        case 'M':
          this.datetimes.splice(1, 1, addMonths(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, addMonths(this.datetimes[0], qntt));
          break;
        case 'W':
          this.datetimes.splice(1, 1, addWeeks(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, addWeeks(this.datetimes[0], qntt));
          break;
        case 'D':
          this.datetimes.splice(1, 1, addDays(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, addDays(this.datetimes[0], qntt));
          break;
        case 'h':
          this.datetimes.splice(1, 1, addHours(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, addHours(this.datetimes[0], qntt));
          break;
        case 'm':
          this.datetimes.splice(1, 1, addMinutes(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, addMinutes(this.datetimes[0], qntt));
          break;
        case 's':
          this.datetimes.splice(1, 1, addSeconds(this.datetimes[1], qntt));
          this.datetimes.splice(0, 1, addSeconds(this.datetimes[0], qntt));
          break;
        default:
          console.log('in DateTimeRangeNavigator, ERROR - Unknown forward term unit.');
      }
      this.emit();
    },
    emit(datetimes = this.datetimes) {
      this.$emit('input', datetimes);
    },
    // BEGIN::Added.by.KWShin.2025.10.20.
    // 2026.09.03.KWShin.다시 수정함
    //   - prevTooltip()과 nextTooltip() 공히 second를 받아 동작하던 것을
    //     숫자와 YMWDhms 단위로 이루어진 스트링을 받아 동작하도록 수정함.
    //     기존에 seconds 단위로 60초 이상의 설정값을 보내던 경우와 호환되도록 함.
    prevTooltip(term) {
      const qntt = parseInt(term.substring(0, term.length - 1));
      const unit = term.substring(term.length - 1);
      if (unit == 's' && qntt > 60) return `${s2Hms(qntt)} ${this.$t('components.tn.previous')}`;
      return `${qntt} ${this.$t('common.term.' + unit)} ${this.$t('components.tn.previous')}`;
    },
    nextTooltip(term) {
      const qntt = parseInt(term.substring(0, term.length - 1));
      const unit = term.substring(term.length - 1);
      if (unit == 's' && qntt > 60) return `${s2Hms(qntt)} ${this.$t('components.tn.next')}`;
      return `${qntt} ${this.$t('common.term.' + unit)} ${this.$t('components.tn.next')}`;
    },
    // FINISH::Added.by.KWShin.2025.10.20.
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  font-size: 11px;
  padding: 3px 5px 3px 5px;
  opacity: 1 !important;
}
</style>
